import {
  FaWhatsapp,
  FaSquareXTwitter,
  FaSquareFacebook,
  FaLinkedin,
} from "react-icons/fa";

import { Link, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./home.css";
import { ToastContainer, toast, Bounce } from "react-toastify";
import Meta from "./components/Meta";
import {
  CreditCard,
  Menu,
  MessageCircle,
  TrendingUp,
  Shield,
  Mail,
  Phone,
  X,
  ExternalLink,
  FileText,
  Building2,
  Receipt,
  ArrowRight,
  Info,
  Calculator,
  CheckCircle,
  Building,
  DollarSign,
  BarChart3,
  Briefcase,
  MessageSquare,
  Award,
  BookOpen,
  Users,
  Calendar,
  GraduationCap,
} from "lucide-react";
import ScrollToTopButton from "./components/ScrollToTop";
import NotificationBar from "./components/NotificationBar";

const Home = () => {
  const [result, setResult] = React.useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const year = new Date().getFullYear();

  const qualifications = [
    { degree: "Fellow Chartered Accountant (FCA)", year: "2014" },
    { degree: "Bachelor of Commerce (B.Com)", year: "2010" },
  ];

  const certifications = [
    { name: "Certificate Course on Concurrent Audit", year: "2016" },
    {
      name: "Certificate Course on Audit of Cooperative Societies and NGOs",
      year: "2016",
    },
    { name: "Certificate Course on Forensic Audit", year: "2016" },
    {
      name: "Certificate Course on Goods and Service Tax Act (GST)",
      year: "2022",
    },
    {
      name: "Certificate Course on Artificial Intelligence (AI)",
      year: "2025",
    },
  ];

  const competencies = [
    "Internal & Statutory Audit of Government Bodies, Corporations, NGOs, and Urban Local Bodies",
    "Taxation Advisory including Income Tax, TDS Compliance, and GST",
    "Company Law and LLP Law Compliances, ROC Filings, and Regulatory Reporting",
    "Bank Audit, including Concurrent and Revenue Audit under RBI norms",
    "Financial Due Diligence, Forensic Accounting, and Investigative Audits",
    "Accounting & MIS Reporting for decision support in public and private entities",
    "Assurance Services for Cooperative Societies and Charitable Institutions",
    "Professional Advisory to government clients on statutory compliance, governance, and audit observations",
  ];

  const resources = [
    {
      id: 1,
      title: "Income Tax Department",
      subtitle: "incometax.gov.in",
      description:
        "Complete income tax solutions including ITR filing, TDS management, and tax compliance services.",
      url: "https://www.incometax.gov.in/",
      icon: FileText,
      color: "from-blue-500 to-blue-600",
      features: [
        "Online ITR Filing",
        "TDS Certificate Download",
        "Tax Payment Gateway",
        "Refund Status Tracking",
      ],
    },
    {
      id: 2,
      title: "Ministry of Corporate Affairs",
      subtitle: "mca.gov.in",
      description:
        "Official portal for company incorporation, ROC filings, and corporate compliance management.",
      url: "https://mca.gov.in",
      icon: Building2,
      color: "from-yellow-400 to-yellow-500",
      features: [
        "Company Registration",
        "Annual Return Filing",
        "Director KYC Services",
        "Compliance Certificates",
      ],
    },
    {
      id: 3,
      title: "GST Portal",
      subtitle: "gst.gov.in",
      description:
        "Comprehensive GST services including registration, return filing, and input tax credit management.",
      url: "https://gst.gov.in",
      icon: Receipt,
      color: "from-blue-600 to-indigo-600",
      features: [
        "GST Registration",
        "GSTR Filing",
        "E-Way Bill System",
        "ITC Reconciliation",
      ],
    },
  ];

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const clientLogos = [
    {
      name: "State Bank of India",
      logo: "/img/sbi.webp",
    },
    {
      name: "Bank of India",
      logo: "/img/boi.png",
    },
    {
      name: "Central Potato Research Institute",
      logo: "/img/cpri.webp",
    },
    {
      name: "Indian Council of Agricultural Research",
      logo: "/img/icar.webp",
    },
    {
      name: "State Council of Education Reasearch and Training",
      logo: "/img/scert.webp",
    },
    {
      name: "Bihar Building & Other Construction Workers Welfare Board",
      logo: "/img/biharwms.webp",
    },
  ];

  const handleWhatsApp = () => {
    window.open("https://wa.me/919934743600", "_blank");
  };

  const handleEmail = () => {
    window.location.href = "mailto:govind@cagovindsinha.com";
  };

  const handlePhone = () => {
    window.location.href = "tel:+919934743600";
  };

  useEffect(() => {
    const targetId = location.state?.scrollTo || location.hash?.substring(1);
    if (targetId) {
      const el = document.getElementById(targetId);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setIsMenuOpen(false);
  };
  let isFirstSubmission = true;
  const onSubmit = async (event) => {
    event.preventDefault();

    if (!isFirstSubmission) {
      toast.warn("DO NOT SPAM THE BUTTON!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      await new Promise((resolve) => setTimeout(resolve, 10000));
    }

    isFirstSubmission = false;

    setResult("Sending....");

    const formData = new FormData(event.target);
    const phone = formData.get("phone");
    const originalMessage = formData.get("message");

    // Combine phone and message
    const combinedMessage = `Phone: ${phone}\n\nMessage: ${originalMessage}`;

    // Create new FormData with combined message
    const finalFormData = new FormData();
    finalFormData.append("access_key", "371d5ae1-c163-4599-a34a-9a5e17b47cbe");
    finalFormData.append("message", combinedMessage);

    for (let [key, value] of formData.entries()) {
      if (key !== "phone" && key !== "message") {
        finalFormData.append(key, value);
      }
    }

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: finalFormData,
    });

    const data = await response.json();
    if (data.success) {
      toast.success("Email has been sent!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      event.target.reset();
    } else {
      toast.error(data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <div className="App">
      <title>
        Govind Sinha & Co. - Best Chartered Accountants in Patna, Bihar
      </title>
      <meta
        name="description"
        content="Govind Sinha & Co. is a leading chartered accountant firm based in Patna, Bihar offering audit, taxation, accounting, GST, and financial consulting services. Expert CA services for businesses and individuals."
      />
      <link rel="canonical" href="https://cagovindsinha.com" />
      <meta
        property="og:title"
        content="Govind Sinha & Co. - Chartered Accountants in Patna, Bihar"
      />
      <meta property="og:url" content="https://cagovindsinha.com/" />
      <meta
        property="og:image"
        content="https://cagovindsinha.com/img/govind.webp"
      />
      <meta property="og:site_name" content="Govind Sinha & Co." />
      <meta
        property="og:description"
        content="Govind Sinha & Co. is a leading chartered accountant firm based in Patna, Bihar offering audit, taxation, accounting, GST, and financial consulting services. Expert CA services for businesses and individuals."
      />
      <meta
        name="twitter:title"
        content="Govind Sinha & Co. - Chartered Accountants in Patna, Bihar"
      />
      <meta
        name="twitter:description"
        content="Expert chartered accountant services based in Patna, Bihar. Specializing in audit, taxation, GST, and financial consulting."
      />
      <meta
        name="twitter:image"
        content="https://cagovindsinha.com/img/govind.webp"
      />
      <ToastContainer />
      <div className="fixed z-50 bottom-6 right-6">
        {/* Contact Options */}
        <div
          className={`flex flex-col-reverse items-end space-y-reverse space-y-4 mb-4 transition-all duration-500 ease-out ${
            isOpen
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-8 pointer-events-none"
          }`}
        >
          {/* WhatsApp */}
          <div className="relative group">
            <button
              onClick={handleWhatsApp}
              className="flex items-center justify-center text-white transition-all duration-300 transform rounded-full shadow-lg w-14 h-14 bg-gradient-to-r from-green-500 to-green-600 hover:shadow-xl hover:scale-110 hover:from-green-600 hover:to-green-700"
            >
              <FaWhatsapp className="w-6 h-6" />
            </button>
            <div className="absolute transition-opacity duration-300 transform -translate-y-1/2 opacity-0 pointer-events-none right-16 top-1/2 group-hover:opacity-100">
              <div className="px-3 py-1 text-sm text-white bg-gray-900 rounded-lg whitespace-nowrap">
                WhatsApp
                <div className="absolute transform -translate-y-1/2 border-4 border-transparent left-full top-1/2 border-l-gray-900"></div>
              </div>
            </div>
          </div>

          {/* Email */}
          <div className="relative group">
            <button
              onClick={handleEmail}
              className="flex items-center justify-center text-white transition-all duration-300 transform rounded-full shadow-lg w-14 h-14 bg-gradient-to-r from-blue-500 to-blue-600 hover:shadow-xl hover:scale-110 hover:from-blue-600 hover:to-blue-700"
            >
              <Mail className="w-6 h-6" />
            </button>
            <div className="absolute transition-opacity duration-300 transform -translate-y-1/2 opacity-0 pointer-events-none right-16 top-1/2 group-hover:opacity-100">
              <div className="px-3 py-1 text-sm text-white bg-gray-900 rounded-lg whitespace-nowrap">
                Email
                <div className="absolute transform -translate-y-1/2 border-4 border-transparent left-full top-1/2 border-l-gray-900"></div>
              </div>
            </div>
          </div>

          {/* Phone */}
          <div className="relative group">
            <button
              onClick={handlePhone}
              className="flex items-center justify-center text-white transition-all duration-300 transform rounded-full shadow-lg w-14 h-14 bg-gradient-to-r from-purple-500 to-purple-600 hover:shadow-xl hover:scale-110 hover:from-purple-600 hover:to-purple-700"
            >
              <Phone className="w-6 h-6" />
            </button>
            <div className="absolute transition-opacity duration-300 transform -translate-y-1/2 opacity-0 pointer-events-none right-16 top-1/2 group-hover:opacity-100">
              <div className="px-3 py-1 text-sm text-white bg-gray-900 rounded-lg whitespace-nowrap">
                Call Us
                <div className="absolute transform -translate-y-1/2 border-4 border-transparent left-full top-1/2 border-l-gray-900"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Toggle Button */}
        <button
          onClick={toggleMenu}
          className={`flex items-center justify-center w-16 h-16 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-full shadow-2xl hover:shadow-3xl transform transition-all duration-500 ease-out hover:scale-105 ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
        >
          <div
            className={`transition-transform duration-300 ${
              isOpen ? "rotate-180" : "rotate-0"
            }`}
          >
            {isOpen ? (
              <X className="w-7 h-7" />
            ) : (
              <MessageSquare className="w-7 h-7" />
            )}
          </div>
        </button>

        {/* Backdrop blur when open */}
        {isOpen && (
          <div
            className="fixed inset-0 bg-black/5 backdrop-blur-[1px] -z-10"
            onClick={toggleMenu}
          />
        )}
      </div>
      {/* Navigation */}
      <nav
        className={`fixed w-full z-50 top-0 transition-all duration-300 ${
          isScrolled
            ? "bg-white/90 backdrop-blur-lg shadow-xl"
            : "bg-white/90 backdrop-blur-sm shadow-xl"
        }`}
      >
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <img
                src="/img/caindia.webp"
                alt="ICAI India"
                className="h-8 mr-3 md:mr-7"
              />
              <Link
                to="/#home"
                onClick={() => scrollToSection("home")}
                className="text-2xl font-bold text-transparent bg-gradient-to-r from-blue-900 to-blue-600 bg-clip-text"
              >
                Govind Sinha & Co.
              </Link>
            </div>

            {/* Desktop Menu */}
            <div className="items-center hidden lg:flex">
              <div className="flex items-baseline ml-10 space-x-4">
                <button
                  onClick={() => scrollToSection("home")}
                  className="nav-link"
                >
                  Home
                </button>
                {/* <button
                  onClick={() => scrollToSection("services")}
                  className="nav-link"
                >
                  Services
    </button> */}
                <Link
                  to="/services"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="nav-link"
                >
                  Services
                </Link>
                <Link
                  to="/checklists"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="nav-link"
                >
                  Checklists
                </Link>
                <button
                  onClick={() => scrollToSection("resources")}
                  className="nav-link"
                >
                  Resources
                </button>
                <button
                  onClick={() => scrollToSection("about")}
                  className="nav-link"
                >
                  About
                </button>

                {/* <Link to="/pay" className="nav-link">
                  Payment
                </Link> */}
                <button
                  onClick={() => scrollToSection("contact")}
                  className="nav-link"
                >
                  Contact
                </button>
              </div>
              <button
                onClick={handleWhatsApp}
                className="flex items-center px-4 py-2 ml-6 space-x-2 text-sm font-medium text-white transition-all duration-300 transform bg-green-500 rounded-full shadow-lg hover:bg-green-600 hover:scale-105"
              >
                <FaWhatsapp className="w-5 h-5" />
                <span>+91 9934743600</span>
              </button>
            </div>

            {/* Mobile menu button */}
            <div className="lg:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 transition-colors hover:text-blue-600"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={
                      isMenuOpen
                        ? "M6 18L18 6M6 6l12 12"
                        : "M4 6h16M4 12h16M4 18h16"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="border-t lg:hidden bg-white/95 backdrop-blur-lg">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <button
                onClick={() => scrollToSection("home")}
                className="mobile-nav-link"
              >
                Home
              </button>
              <Link
                to="/services"
                // onClick={() => window.scrollTo(0, 0)}
                className="mobile-nav-link"
              >
                Services
              </Link>
              <Link
                to="/checklists"
                // onClick={() => window.scrollTo(0, 0)}
                className="mobile-nav-link"
              >
                Checklists
              </Link>
              <button
                onClick={() => scrollToSection("resources")}
                className="mobile-nav-link"
              >
                Resources
              </button>
              <button
                onClick={() => scrollToSection("about")}
                className="mobile-nav-link"
              >
                About
              </button>

              {/* <Link to="/pay" className="mobile-nav-link">
                Payment
              </Link> */}
              <button
                onClick={() => scrollToSection("contact")}
                className="mobile-nav-link"
              >
                Contact
              </button>
            </div>
          </div>
        )}
      </nav>
      <NotificationBar />
      {/* Hero Section */}
      <section
        id="home"
        className="relative h-auto overflow-hidden motion-preset-blur-down motion-duration-700 motion-delay-100 transform-gpu bg-gradient-to-br from-yellow-50 via-blue-100 to-purple-100"
      >
        {/* Animated Background Elements */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute rounded-full top-20 left-10 w-72 h-72 bg-gradient-to-r from-yellow-300 to-yellow-400 mix-blend-multiply filter blur-xl animate-pulse"></div>
          <div className="absolute rounded-full top-40 right-10 w-96 h-96 bg-gradient-to-r from-blue-400 to-purple-400 mix-blend-multiply filter blur-xl animate-pulse animation-delay-2000"></div>
          <div className="absolute rounded-full -bottom-20 left-1/2 w-80 h-80 bg-gradient-to-r from-purple-300 to-pink-300 mix-blend-multiply filter blur-xl animate-pulse animation-delay-4000"></div>
        </div>
        {/* Hero Section */}
        <div className="container relative z-10 px-6 py-16 pt-8 mx-auto max-w-7xl">
          <div className="grid items-center h-auto gap-12 lg:grid-cols-2">
            {/* Left Content */}
            <div className="space-y-8">
              <div className="inline-flex items-center px-4 py-2 text-sm font-medium text-yellow-800 bg-yellow-100 rounded-full">
                <TrendingUp className="w-4 h-4 mr-2" />
                Trusted Financial Partner
              </div>

              <h1 className="text-5xl font-bold leading-tight text-gray-900 lg:text-6xl">
                Your Trusted
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
                  Financial
                </span>
                Partner
              </h1>

              <p className="max-w-lg text-xl leading-relaxed text-gray-600">
                Chartered Accountants delivering excellence in taxation,
                auditing, and financial advisory services. Building your
                business success with precision and integrity.
              </p>

              <div className="space-y-4">
                {[
                  "Tax Planning & Compliance",
                  "Audit & Assurance",
                  "Business Registration",
                ].map((service, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <CheckCircle className="w-5 h-5 text-green-500" />
                    <span className="text-gray-700">{service}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col gap-4 sm:flex-row">
                <button
                  className="group relative inline-flex items-center px-8 py-4 font-semibold text-white transition-all duration-500 ease-out overflow-hidden bg-gradient-to-br from-indigo-500 via-purple-600 to-pink-600 rounded-xl shadow-2xl hover:shadow-indigo-500/25 focus:outline-none focus:ring-4 focus:ring-purple-500/50 active:scale-[0.98] hover:scale-[1.02] transform-gpu"
                  onClick={() => scrollToSection("contact")}
                >
                  {/* Animated background gradient */}
                  <div className="absolute inset-0 transition-opacity duration-700 ease-out opacity-0 bg-gradient-to-br from-pink-500 via-purple-500 to-indigo-600 group-hover:opacity-100 rounded-xl"></div>

                  {/* Shimmer sweep */}
                  <div className="absolute inset-0 transition-transform duration-1000 ease-in-out -translate-x-full group-hover:translate-x-full">
                    <div className="w-8 h-full skew-x-12 bg-gradient-to-r from-transparent via-white/30 to-transparent blur-sm"></div>
                  </div>

                  {/* Subtle pulse ring */}
                  <div className="absolute inset-0 transition-all duration-300 rounded-xl ring-1 ring-white/20 group-hover:ring-white/40"></div>

                  {/* Inner highlight */}
                  <div className="absolute transition-opacity duration-300 inset-px bg-gradient-to-br from-white/10 to-transparent rounded-xl opacity-60 group-hover:opacity-90"></div>

                  {/* Content */}
                  <span className="relative z-10">Contact Us</span>

                  {/* Animated arrow */}
                  <ArrowRight className="relative z-10 w-5 h-5 ml-2 transition-all duration-300 ease-out group-hover:translate-x-1 group-hover:scale-110" />

                  {/* Active state ripple */}
                  <div className="absolute inset-0 transition-all duration-150 ease-out scale-0 opacity-0 bg-white/10 rounded-xl group-active:scale-95 group-active:opacity-100"></div>
                </button>

                <Link
                  to="/services"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="inline-flex items-center px-8 py-4 font-semibold text-gray-700 transition-all duration-300 ease-in-out border-2 border-yellow-400 rounded-xl hover:bg-yellow-50 active:scale-90"
                >
                  <Calculator className="w-5 h-5 mr-2" />
                  View Services
                </Link>

                {/* <Link
                  to="/pay"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="inline-flex items-center gap-3 px-8 py-4 font-semibold text-white transition-all duration-200 ease-in-out bg-blue-600 shadow-lg rounded-xl hover:bg-blue-700 hover:scale-105 active:scale-90"
                >
                  <CreditCard className="w-5 h-5" />
                  <span>Payment</span>
                  <ArrowRight className="w-5 h-5" />
                </Link> */}
              </div>
            </div>

            {/* Right Content - Founder Image Placeholder */}
            <div className="flex justify-center lg:justify-end">
              <div className="relative">
                <div className="flex items-center justify-center overflow-hidden border shadow-2xl w-80 h-96 bg-gradient-to-br from-yellow-200 to-blue-200 rounded-2xl border-white/50 backdrop-blur-sm">
                  <img
                    src="/img/govind.webp"
                    alt="CA Govind Sinha - Founder"
                    className="object-cover w-full h-full rounded-2xl"
                  />
                </div>

                {/* Decorative Elements */}
                <div className="absolute w-12 h-12 rounded-full -top-4 -right-4 bg-gradient-to-r from-yellow-400 to-orange-400 opacity-90 animate-bounce"></div>
                <div className="absolute w-8 h-8 rounded-full -bottom-4 -left-4 bg-gradient-to-r from-purple-400 to-pink-400 opacity-80 animate-pulse"></div>
                <div className="absolute w-6 h-6 rounded-full top-1/2 -left-8 bg-gradient-to-r from-blue-400 to-cyan-400 opacity-70 animate-ping"></div>

                {/* Founder Info */}
                <div className="absolute px-10 py-4 transform -translate-x-1/2 border shadow-xl -bottom-12 left-1/2 bg-white/95 backdrop-blur-sm rounded-2xl border-white/20 whitespace-nowrap">
                  <div className="text-center">
                    <div className="mb-1 text-xl font-bold text-gray-900">
                      CA Govind Sinha
                    </div>
                    <div className="text-sm font-medium text-gray-600">
                      10+ Years of Experience
                    </div>
                    <div className="flex justify-center mt-2">
                      <div className="w-12 h-1 rounded-full bg-gradient-to-r from-blue-500 to-purple-500"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Our Clients Section */}
        <div className="border-t border-gray-200 bg-white/70 backdrop-blur-sm">
          <div className="container px-6 py-8 mx-auto max-w-7xl">
            <div className="mb-6 text-center">
              <h2 className="text-2xl font-semibold text-gray-700">
                Trusted by
              </h2>
            </div>

            <div className="flex flex-wrap items-center justify-center space-x-6 space-y-6 md:space-y-0 md:flex-nowrap md:space-x-28">
              {clientLogos.map((client, index) => (
                <div
                  key={index}
                  className="relative flex items-center justify-center group"
                >
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="object-contain w-auto h-16 md:h-32"
                  />
                  <div className="absolute px-4 py-2 text-sm font-medium text-gray-800 transition-all duration-300 transform -translate-x-1/2 border shadow-lg opacity-0 bg-white/90 backdrop-blur-md rounded-xl -top-12 left-1/2 group-hover:opacity-100 group-hover:-translate-y-1 whitespace-nowrap border-white/20">
                    {client.name}
                    <div className="absolute w-2 h-2 transform rotate-45 -translate-x-1/2 border-b border-r bg-white/90 backdrop-blur-md -bottom-1 left-1/2 border-white/20"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/*<section
        id="home"
        className="relative flex items-center justify-center min-h-screen overflow-hidden"
      >
        <div
          className="absolute inset-0 bg-gradient-to-br from-blue-900/90 to-blue-800/80"
          style={{
            backgroundImage: `url("/img/hero.avif")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>

        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/70 to-transparent"></div>

        <div className="relative z-10 max-w-5xl px-4 mx-auto text-center text-white">
          <h1 className="mb-6 text-5xl font-bold leading-tight md:text-7xl">
            Your Trusted
            <span className="block text-transparent bg-gradient-to-r drop-shadow-md from-yellow-400 to-yellow-200 bg-clip-text">
              Financial Partner
            </span>
          </h1>
          <p className="max-w-3xl mx-auto mb-8 text-xl leading-relaxed text-blue-100 drop-shadow-md md:text-2xl">
            Chartered Accountants delivering excellence in taxation, auditing,
            and financial advisory services. Building your business success with
            precision and integrity.
          </p>
          <div className="flex flex-col justify-center gap-4 sm:flex-row">
            <button
              onClick={() => scrollToSection("contact")}
              className="px-8 py-4 text-lg premium-btn-primary"
            >
              Contact Us
            </button>
            <Link
              to="/services"
              className="px-8 py-4 text-lg premium-btn-secondary"
            >
              Explore Services
            </Link>

            <button
              onClick={() => scrollToSection("resources")}
              className="px-8 py-4 text-lg font-bold transition-all duration-200 ease-in-out border-none shadow-lg cursor-pointer text-amber-400 bg-gradient-to-r from-blue-800 to-blue-900 rounded-xl hover:shadow-xl hover:scale-105 hover:from-blue-700 hover:to-blue-800"
            >
              Portals
            </button>
          </div>
        </div>

        {/* Scroll indicator */}{" "}
      {/*
        <div className="absolute transform -translate-x-1/2 bottom-8 left-1/2 animate-bounce">
          <div className="flex justify-center w-6 h-10 border-2 rounded-full border-white/50">
            <div className="w-1 h-3 mt-2 rounded-full bg-white/70 animate-pulse"></div>
          </div>
        </div>
      </section> 
      */}
      {/* Services Section */}
      <section
        id="services"
        className="py-20 bg-gradient-to-b from-gray-50 to-white"
      >
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="mb-16 text-center">
            <h2 className="mb-6 text-4xl font-bold text-gray-900 md:text-5xl">
              Professional Services
            </h2>
            <p className="max-w-3xl mx-auto text-xl text-gray-600">
              Comprehensive financial solutions tailored to your business needs
              with expert guidance every step of the way.
            </p>
          </div>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {/* Service 1 */}
            <div className="service-card group">
              <div className="service-icon-container">
                <Calculator className="service-icon" strokeWidth={2.5} />
              </div>
              <h3 className="mb-4 text-2xl font-bold text-gray-900">
                Tax Advisory & Compliance
              </h3>
              <p className="mb-6 text-gray-600">
                Expert tax planning, filing, and compliance services to minimize
                your tax liability while ensuring full regulatory compliance.
              </p>
              <ul className="space-y-2 text-sm text-gray-500">
                <li>• Income Tax Returns</li>
                <li>• GST Registration & Filing</li>
                <li>• Tax Planning Strategies</li>
                <li>• TDS & Advance Tax</li>
              </ul>
            </div>

            {/* Service 2 */}
            <div className="service-card group">
              <div className="service-icon-container">
                <CheckCircle className="service-icon" strokeWidth={2.5} />
              </div>
              <h3 className="mb-4 text-2xl font-bold text-gray-900">
                Audit & Assurance
              </h3>
              <p className="mb-6 text-gray-600">
                Comprehensive audit services providing transparency, accuracy,
                and confidence in your financial statements.
              </p>
              <ul className="space-y-2 text-sm text-gray-500">
                <li>• Statutory Audits</li>
                <li>• Internal Audits</li>
                <li>• Stock Audits</li>
                <li>• Management Audits</li>
              </ul>
            </div>

            {/* Service 3 */}
            <div className="service-card group">
              <div className="service-icon-container">
                <Building className="service-icon" strokeWidth={2.5} />
              </div>
              <h3 className="mb-4 text-2xl font-bold text-gray-900">
                Business Registration
              </h3>
              <p className="mb-6 text-gray-600">
                Complete business setup and registration services to get your
                venture started with proper legal framework.
              </p>
              <ul className="space-y-2 text-sm text-gray-500">
                <li>• Company Incorporation</li>
                <li>• Partnership Registration</li>
                <li>• LLP Formation</li>
                <li>• NGO Registration</li>
              </ul>
            </div>

            {/* Service 4 */}
            <div className="service-card group">
              <div className="service-icon-container">
                <DollarSign className="service-icon" strokeWidth={2.5} />
              </div>
              <h3 className="mb-4 text-2xl font-bold text-gray-900">
                Financial Planning
              </h3>
              <p className="mb-6 text-gray-600">
                Strategic financial planning and investment advisory to secure
                your financial future and business growth.
              </p>
              <ul className="space-y-2 text-sm text-gray-500">
                <li>• Investment Advisory</li>
                <li>• Retirement Planning</li>
                <li>• Wealth Management</li>
                <li>• Risk Assessment</li>
              </ul>
            </div>

            {/* Service 5 */}
            <div className="service-card group">
              <div className="bg-center bg-cover service-icon-container">
                <div className="absolute inset-0 bg-blue-600/80 rounded-xl"></div>
                <BarChart3
                  className="relative z-10 service-icon"
                  strokeWidth={2.5}
                />
              </div>
              <h3 className="mb-4 text-2xl font-bold text-gray-900">
                Bookkeeping & Accounting
              </h3>
              <p className="mb-6 text-gray-600">
                Meticulous bookkeeping and accounting services to maintain
                accurate financial records and insights.
              </p>
              <ul className="space-y-2 text-sm text-gray-500">
                <li>• Monthly Bookkeeping</li>
                <li>• Financial Statements</li>
                <li>• Cash Flow Management</li>
                <li>• Payroll Processing</li>
              </ul>
            </div>

            {/* Service 6 */}
            <div className="service-card group">
              <div className="service-icon-container">
                <Briefcase className="service-icon" strokeWidth={2.5} />
              </div>
              <h3 className="mb-4 text-2xl font-bold text-gray-900">
                Business Consulting
              </h3>
              <p className="mb-6 text-gray-600">
                Strategic business consulting to optimize operations, improve
                profitability, and drive sustainable growth.
              </p>
              <ul className="space-y-2 text-sm text-gray-500">
                <li>• Business Strategy</li>
                <li>• Process Optimization</li>
                <li>• Financial Analysis</li>
                <li>• Growth Planning</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 text-center">
          <Link
            to="/services"
            // onClick={() => window.scrollTo(0, 0)}
            className="inline-block px-6 py-3 text-lg font-semibold text-white transition bg-blue-600 rounded-lg shadow-md hover:bg-blue-700"
          >
            Explore All Services
          </Link>
        </div>
      </section>
      {/* About Section */}
      <section className="py-20 bg-gradient-to-r from-blue-50 to-indigo-50">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <div>
              <h2 className="mb-6 text-4xl font-bold text-gray-900 md:text-5xl">
                Excellence in Financial Services
              </h2>
              <p className="mb-8 text-xl leading-relaxed text-gray-600">
                With over 10 years of experience in chartered accountancy, we
                bring deep expertise, unwavering integrity, and personalized
                service to every client relationship.
              </p>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl">
                      <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <h3 className="mb-2 text-xl font-semibold text-gray-900">
                      Certified Excellence
                    </h3>
                    <p className="text-gray-600">
                      Licensed Chartered Accountants with continuous
                      professional development and industry certifications.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-green-600 to-emerald-600 rounded-xl">
                      <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <h3 className="mb-2 text-xl font-semibold text-gray-900">
                      Client-Centric Approach
                    </h3>
                    <p className="text-gray-600">
                      Personalized service with dedicated attention to your
                      unique business needs and financial goals.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl">
                      <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13 10V3L4 14h7v7l9-11h-7z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <h3 className="mb-2 text-xl font-semibold text-gray-900">
                      Technology-Driven
                    </h3>
                    <p className="text-gray-600">
                      Modern digital solutions and automated processes for
                      efficient, accurate, and timely service delivery.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative overflow-hidden shadow-2xl rounded-2xl">
                <img
                  src="https://images.unsplash.com/photo-1544717297-fa95b6ee9643"
                  alt="Professional team at work"
                  className="object-cover w-full h-96"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent"></div>
              </div>

              {/* Stats overlay */}
              <div className="absolute p-6 bg-white border border-gray-100 shadow-xl -bottom-6 -left-6 rounded-xl">
                <div className="flex items-center space-x-4">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-blue-600">
                      1000+
                    </div>
                    <div className="text-sm text-gray-600">Happy Clients</div>
                  </div>
                  <div className="w-px h-12 bg-gray-200"></div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-green-600">10+</div>
                    <div className="text-sm text-gray-600">
                      Years Experience
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Staff Section */}
      <section
        id="about"
        className="relative py-20 overflow-hidden bg-gradient-to-br from-gray-50 via-slate-50 to-cyan-50"
      >
        {/* Background Elements */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute rounded-full top-10 right-10 w-96 h-96 bg-gradient-to-r from-blue-300 to-purple-300 mix-blend-multiply filter blur-3xl animate-pulse"></div>
          <div className="absolute rounded-full bottom-10 left-10 w-80 h-80 bg-gradient-to-r from-yellow-200 to-orange-200 mix-blend-multiply filter blur-3xl animate-pulse animation-delay-2000"></div>
        </div>

        <div className="container relative z-10 px-6 mx-auto">
          {/* Section Header */}
          <div className="mb-16 text-center">
            <div className="inline-flex items-center px-4 py-2 mb-4 text-sm font-medium text-blue-800 bg-blue-100 rounded-full">
              <Users className="w-4 h-4 mr-2" />
              Meet Our Founder
            </div>
            <h2 className="mb-4 text-4xl font-bold text-gray-900 md:text-5xl">
              About Our
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
                Founder
              </span>
            </h2>
          </div>

          {/* Main Content */}
          <div className="grid items-start gap-12 lg:grid-cols-2">
            {/* Left Column - Profile */}
            <div className="space-y-8">
              {/* Profile Card */}
              <div className="p-8 border shadow-xl bg-white/80 backdrop-blur-sm rounded-3xl border-white/20">
                <div className="flex items-center mb-6 space-x-4">
                  <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl">
                    <Award className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">
                      CA Govind Kumar Sinha, FCA
                    </h3>
                    <p className="text-lg text-gray-600">
                      Founder | Practicing Chartered Accountant
                    </p>
                  </div>
                </div>

                <p className="mb-6 leading-relaxed text-gray-700">
                  <strong>CA Govind Kumar Sinha</strong> is a{" "}
                  <strong>
                    Fellow Member of the Institute of Chartered Accountants of
                    India (FCA)
                  </strong>{" "}
                  with over <strong>a decade of professional experience</strong>{" "}
                  in the domain of{" "}
                  <strong>
                    audit, assurance, taxation, forensic accounting, and
                    financial consultancy
                  </strong>
                  .
                </p>

                <p className="mb-6 leading-relaxed text-gray-700">
                  His expertise spans across{" "}
                  <strong>
                    government, PSU, cooperative, and private sector audits
                  </strong>
                  , with a consistent record of delivering quality,
                  compliance-driven, and time-bound professional services.
                </p>

                <div className="p-6 border border-blue-100 bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl">
                  <p className="leading-relaxed text-gray-700">
                    He is founder of{" "}
                    <strong>
                      M/s GOVIND SINHA & CO, Chartered Accountants
                    </strong>
                    , a reputed professional firm engaged in multi-disciplinary
                    assignments across Bihar and other parts of India.
                  </p>
                </div>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-3 md:gap-4">
                <div className="p-4 text-center border shadow-lg md:p-6 bg-white/80 backdrop-blur-sm rounded-2xl border-white/20">
                  <div className="mb-2 text-3xl font-bold text-blue-600">
                    10+
                  </div>
                  <div className="text-sm text-gray-600">Years Experience</div>
                </div>
                <div className="p-4 text-center border shadow-lg md:p-6 bg-white/80 backdrop-blur-sm rounded-2xl border-white/20">
                  <div className="mb-2 text-3xl font-bold text-purple-600">
                    5+
                  </div>
                  <div className="text-sm text-gray-600">Certifications</div>
                </div>
                <div className="p-4 text-center border shadow-lg md:p-6 bg-white/80 backdrop-blur-sm rounded-2xl border-white/20">
                  <div className="mb-2 text-3xl font-bold text-green-600">
                    1000+
                  </div>
                  <div className="text-sm text-gray-600">Clients Served</div>
                </div>
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="space-y-8">
              {/* Educational Credentials */}
              <div className="p-8 border shadow-xl bg-white/80 backdrop-blur-sm rounded-3xl border-white/20">
                <div className="flex items-center mb-6 space-x-3">
                  <GraduationCap className="w-6 h-6 text-blue-600" />
                  <h3 className="text-xl font-bold text-gray-900">
                    Educational & Professional Credentials
                  </h3>
                </div>

                <div className="mb-8 space-y-4">
                  {qualifications.map((qual, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between p-4 border border-blue-100 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl"
                    >
                      <span className="font-semibold text-gray-800">
                        {qual.degree}
                      </span>
                      <span className="font-medium text-blue-600">
                        {qual.year}
                      </span>
                    </div>
                  ))}
                </div>

                <h4 className="mb-4 font-semibold text-gray-900">
                  Specialized Professional Certifications from ICAI:
                </h4>
                <div className="space-y-3">
                  {certifications.map((cert, index) => (
                    <div key={index} className="flex items-start space-x-3">
                      <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                      <div className="flex-1">
                        <span className="text-gray-700">{cert.name}</span>
                        <span className="ml-2 font-medium text-blue-600">
                          ({cert.year})
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Core Competencies - Full Width Section */}
          <div className="mt-16">
            <div className="p-8 border shadow-xl bg-white/80 backdrop-blur-sm rounded-3xl border-white/20">
              <div className="flex items-center justify-center mb-8 space-x-3">
                <TrendingUp className="w-6 h-6 text-purple-600" />
                <h3 className="text-2xl font-bold text-gray-900">
                  Areas of Practice & Core Competencies
                </h3>
              </div>

              <div className="grid gap-6 md:grid-cols-2">
                {competencies.map((competency, index) => (
                  <div
                    key={index}
                    className="flex items-start p-6 space-x-4 transition-all duration-300 border border-gray-100 bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl hover:border-blue-200 hover:shadow-md"
                  >
                    <div className="flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg bg-gradient-to-r from-blue-600 to-purple-600">
                      <Building className="w-4 h-4 text-white" />
                    </div>
                    <span className="leading-relaxed text-gray-700">
                      {competency}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section id="testimonials" className="py-20 bg-white">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="mb-16 text-center">
            <h2 className="mb-6 text-4xl font-bold text-gray-900 md:text-5xl">
              Client Success Stories
            </h2>
            <p className="max-w-3xl mx-auto text-xl text-gray-600">
              Hear from our satisfied clients about their experience working
              with our team of chartered accountants.
            </p>
          </div>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {/* Testimonial 1 */}
            <div className="testimonial-card">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-yellow-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              <p className="mb-6 italic text-gray-600">
                "A professional of standard quality and sound integrity."
              </p>
              <div className="flex items-center">
                <div
                  className="w-12 h-12 mr-4 bg-gray-300 bg-center bg-cover rounded-full"
                  style={{
                    backgroundImage: `url('/img/smcs.webp')`,
                  }}
                ></div>
                <div>
                  <h4 className="font-semibold text-gray-900">SK Mehta</h4>
                  {/* <p className="text-sm text-gray-500">SK Mehta</p> */}
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="testimonial-card">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-yellow-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              <p className="mb-6 italic text-gray-600">
                "Highly recommended for individuals and businesses looking for
                reliable and top-notch CA services! Their team is highly
                professional, knowledgeable, and extremely efficient in handling
                all aspects of accounting, taxation, and compliance."
              </p>
              <div className="flex items-center">
                <div
                  className="w-12 h-12 mr-4 bg-gray-300 bg-center bg-cover rounded-full"
                  style={{
                    backgroundImage: `url('/img/abhishek_das.avif')`,
                  }}
                ></div>
                <div>
                  <h4 className="font-semibold text-gray-900">Abhishek Das</h4>
                  {/* <p className="text-sm text-gray-500">
                    Founder, GreenLeaf Organics
                </p> */}
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="testimonial-card">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-yellow-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              <p className="mb-6 italic text-gray-600">
                "Working with Govind Sinha & Co. has been smooth and
                hassle-free. They are reliable, responsive, and take care of all
                compliance matters efficiently."
              </p>
              <div className="flex items-center">
                <div
                  className="w-12 h-12 mr-4 bg-gray-300 bg-center bg-cover rounded-full"
                  style={{
                    backgroundImage: `url('/img/rakeshpatel.webp')`,
                  }}
                ></div>
                <div>
                  <h4 className="font-semibold text-gray-900">Rakesh Patel</h4>
                  {/*<p className="text-sm text-gray-500">
                    Director, Manufacturing Hub
                </p>*/}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 text-center">
            <button
              onClick={() =>
                window.open(
                  "https://maps.app.goo.gl/eCKjLTCRqaDcoxfB6",
                  "_blank"
                )
              }
              className="inline-block px-6 py-3 text-lg font-semibold text-white transition bg-yellow-400 rounded-lg shadow-md hover:bg-yellow-500"
            >
              Rate Us
            </button>
          </div>
        </div>
      </section>
      <section
        id="resources"
        className="relative py-24 overflow-hidden bg-white"
      >
        {/* Background Elements */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 via-white to-yellow-50/30"></div>
        <div className="absolute top-0 left-0 -translate-x-48 -translate-y-48 rounded-full w-96 h-96 bg-yellow-200/20 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 translate-x-48 translate-y-48 rounded-full w-96 h-96 bg-blue-200/20 blur-3xl"></div>

        <div className="relative max-w-6xl px-4 mx-auto sm:px-6 lg:px-8">
          {/* Header Section */}
          <div className="mb-20 text-center">
            <div className="inline-flex items-center px-4 py-2 mb-6 text-sm font-medium text-yellow-800 bg-yellow-100 rounded-full">
              <Info className="w-4 h-4 mr-2" />
              Government Resources
            </div>
            <h2 className="mb-6 text-5xl font-extrabold leading-tight text-gray-900">
              Essential{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-blue-600">
                Government
              </span>{" "}
              Portals
            </h2>
            <p className="max-w-2xl mx-auto text-xl leading-relaxed text-gray-600">
              Direct access to official government websites for seamless tax
              compliance and business operations
            </p>
          </div>

          {/* Resources Grid */}
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 md:grid-cols-2">
            {resources.map((resource, index) => {
              const IconComponent = resource.icon;
              return (
                <div
                  key={resource.id}
                  className="relative p-8 transition-all duration-500 border shadow-md group bg-white/80 backdrop-blur-sm rounded-3xl border-gray-100/50 hover:border-yellow-200 hover:shadow-xl hover:shadow-blue-100/50"
                  style={{
                    animationDelay: `${index * 100}ms`,
                  }}
                >
                  {/* Icon Header */}
                  <div className="flex items-center justify-between mb-6">
                    <div
                      className={`p-4 rounded-2xl bg-gradient-to-r ${resource.color} shadow-lg`}
                    >
                      <IconComponent className="text-white w-7 h-7" />
                    </div>
                    <div className="transition-opacity duration-300 opacity-0 group-hover:opacity-100">
                      <ExternalLink className="w-5 h-5 text-gray-400" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="mb-8 space-y-4">
                    <div>
                      <h3 className="mb-1 text-2xl font-bold text-gray-900 transition-colors group-hover:text-blue-600">
                        {resource.title}
                      </h3>
                      <p className="text-sm font-medium text-yellow-600">
                        {resource.subtitle}
                      </p>
                    </div>

                    <p className="leading-relaxed text-gray-600">
                      {resource.description}
                    </p>
                  </div>

                  {/* Features */}
                  <div className="mb-8 space-y-3">
                    {resource.features.map((feature, idx) => (
                      <div
                        key={idx}
                        className="flex items-center text-sm text-gray-700"
                      >
                        <div className="w-1.5 h-1.5 bg-yellow-400 rounded-full mr-3 flex-shrink-0"></div>
                        {feature}
                      </div>
                    ))}
                  </div>

                  {/* CTA Link */}
                  <a
                    href={resource.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="relative inline-flex items-center justify-center w-full px-6 py-4 overflow-hidden font-semibold text-white transition-all duration-300 bg-gray-900 group/btn hover:bg-black rounded-2xl"
                  >
                    <span className="relative z-10 flex items-center">
                      Visit Portal
                      <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover/btn:translate-x-1" />
                    </span>
                    <div className="absolute inset-0 transition-opacity duration-300 opacity-0 bg-gradient-to-r from-yellow-400 to-blue-600 group-hover/btn:opacity-100"></div>
                  </a>

                  {/* Decorative Element */}
                  <div className="absolute w-20 h-20 transition-opacity duration-500 rounded-full opacity-0 top-4 right-4 bg-gradient-to-br from-yellow-100/50 to-blue-100/50 blur-2xl group-hover:opacity-100"></div>
                </div>
              );
            })}
          </div>

          {/* Bottom Info Banner */}
          <div className="mt-20 text-center">
            <div className="inline-flex items-center px-8 py-4 space-x-4 border bg-gradient-to-r from-yellow-50 to-blue-50 border-yellow-200/50 rounded-2xl">
              <div className="flex items-center space-x-2 text-gray-700">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="font-medium">
                  All portals are officially verified
                </span>
              </div>
              <div className="hidden w-px h-6 bg-gray-300 sm:block"></div>
              <span className="hidden text-gray-600 sm:inline">
                Need assistance? Our experts are here to help
              </span>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section
        id="contact"
        className="py-20 text-white bg-gradient-to-b from-blue-900 to-blue-800"
      >
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="mb-16 text-center">
            <h2 className="mb-6 text-4xl font-bold md:text-5xl">
              Ready to Get Started?
            </h2>
            <p className="max-w-3xl mx-auto text-xl text-blue-100">
              Schedule a consultation with our chartered accountants and
              discover how we can help optimize your financial success.
            </p>
          </div>

          <div className="grid gap-12 lg:grid-cols-2">
            {/* Contact Form */}
            <div className="p-8 border bg-white/10 backdrop-blur-lg rounded-2xl border-white/20">
              <h3 className="mb-6 text-2xl font-bold">Send us a Message</h3>
              <form className="space-y-6" onSubmit={onSubmit}>
                <div className="grid gap-4">
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-100">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="w-full px-4 py-3 text-white placeholder-blue-200 transition-all border bg-white/10 border-white/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                      placeholder="Ashok Kumar"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium text-blue-100">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="w-full px-4 py-3 text-white placeholder-blue-200 transition-all border bg-white/10 border-white/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                    placeholder="ashok@gmail.com"
                    required
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-medium text-blue-100">
                    Phone
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    className="w-full px-4 py-3 text-white placeholder-blue-200 transition-all border bg-white/10 border-white/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                    placeholder="+91 98765 43210"
                    required
                  />
                </div>
                <input
                  type="checkbox"
                  name="botcheck"
                  className="hidden"
                  style={{ display: "none" }}
                ></input>
                <input
                  type="hidden"
                  name="from_name"
                  value="cagovindsinha.com"
                ></input>

                <div>
                  <label className="block mb-2 text-sm font-medium text-blue-100">
                    Message
                  </label>
                  <textarea
                    name="message"
                    rows="4"
                    className="w-full px-4 py-3 text-white placeholder-blue-200 transition-all border resize-none bg-white/10 border-white/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                    placeholder="Tell us about your requirements..."
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full px-8 py-4 font-bold text-blue-900 transition-all duration-200 transform shadow-lg bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-xl hover:from-yellow-300 hover:to-yellow-400 hover:scale-105"
                >
                  Send Message
                </button>
              </form>
            </div>

            {/* Contact Information */}
            <div className="space-y-8">
              <div>
                <h3 className="mb-6 text-2xl font-bold">Get in Touch</h3>
                <p className="mb-8 text-blue-100">
                  Contact us today for expert financial guidance and
                  personalized solutions for your business needs.
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 bg-yellow-400/20 rounded-xl">
                      <svg
                        className="w-6 h-6 text-yellow-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <h4 className="mb-1 text-lg font-semibold text-white">
                      Office Address
                    </h4>
                    <a
                      href="https://maps.app.goo.gl/vxBFC4HWTFof4oGV8"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-100 hover:text-yellow-400"
                    >
                      7th Floor, Adharshila Complex
                      <br />
                      503, beside Reserve Bank of India(RBI)
                      <br />
                      South Gandhi Maidan
                      <br />
                      Patna, Bihar 800001
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 bg-yellow-400/20 rounded-xl">
                      <svg
                        className="w-6 h-6 text-yellow-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <h4 className="mb-1 text-lg font-semibold text-white">
                      Phone Numbers
                    </h4>
                    <a
                      href="tel: +917673040500"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block text-blue-100 hover:text-yellow-400"
                    >
                      +91 7673040500
                    </a>
                    <a
                      href="tel: +919934743600"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block text-blue-100 hover:text-yellow-400"
                    >
                      +91 9934743600
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 bg-yellow-400/20 rounded-xl">
                      <svg
                        className="w-6 h-6 text-yellow-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <h4 className="mb-1 text-lg font-semibold text-white">
                      Email Addresses
                    </h4>
                    <a
                      href="mailto:govind@cagovindsinha.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-100 hover:text-yellow-400"
                    >
                      govind@cagovindsinha.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center w-12 h-12 bg-yellow-400/20 rounded-xl">
                      <svg
                        className="w-6 h-6 text-yellow-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div>
                    <h4 className="mb-1 text-lg font-semibold text-white">
                      Business Hours
                    </h4>
                    <p className="text-blue-100">
                      Monday - Saturday: 10:30 AM - 7:00 PM
                      <br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="py-16 text-white bg-gray-900">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="grid gap-8 mb-8 md:grid-cols-2 lg:grid-cols-4">
            {/* Company Info */}
            <div>
              <div className="mb-4 text-2xl font-bold text-transparent bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text">
                Govind Sinha & Co.
              </div>
              <p className="mb-6 text-gray-400">
                Your trusted partner for comprehensive chartered accountancy
                services, delivering excellence with integrity and precision.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://x.com/cagovindsinha"
                  className="flex items-center justify-center w-10 h-10 transition-colors bg-blue-600 rounded-full hover:bg-blue-700"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/in/ca-govind-sinha-b92306173/"
                  className="flex items-center justify-center w-10 h-10 transition-colors bg-blue-800 rounded-full hover:bg-blue-900"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
                <a
                  href="https://www.facebook.com/sinha.govind"
                  className="flex items-center justify-center w-10 h-10 transition-colors bg-blue-600 rounded-full hover:bg-blue-700"
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Services */}
            <div>
              <h3 className="mb-4 text-xl font-bold">Our Services</h3>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a
                    href="/services"
                    className="transition-colors hover:text-yellow-400"
                  >
                    Tax Advisory
                  </a>
                </li>
                <li>
                  <a
                    href="/services"
                    className="transition-colors hover:text-yellow-400"
                  >
                    Audit & Assurance
                  </a>
                </li>
                <li>
                  <a
                    href="/services"
                    className="transition-colors hover:text-yellow-400"
                  >
                    Business Registration
                  </a>
                </li>
                <li>
                  <a
                    href="/services"
                    className="transition-colors hover:text-yellow-400"
                  >
                    Financial Planning
                  </a>
                </li>
                <li>
                  <a
                    href="/services"
                    className="transition-colors hover:text-yellow-400"
                  >
                    Bookkeeping
                  </a>
                </li>
                <li>
                  <a
                    href="/services"
                    className="transition-colors hover:text-yellow-400"
                  >
                    Business Consulting
                  </a>
                </li>
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="mb-4 text-xl font-bold">Quick Links</h3>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <button
                    onClick={() => scrollToSection("home")}
                    className="transition-colors hover:text-yellow-400"
                  >
                    Home
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("about")}
                    className="transition-colors hover:text-yellow-400"
                  >
                    About Us
                  </button>
                </li>
                <li>
                  <Link
                    to="/services"
                    // onClick={() => window.scrollTo(0, 0)}
                    className="transition-colors hover:text-yellow-400"
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link
                    to="/checklists"
                    // onClick={() => window.scrollTo(0, 0)}
                    className="transition-colors hover:text-yellow-400"
                  >
                    Checklists
                  </Link>
                </li>
                {/* <li>
                  <Link
                    to="/pay"
                    // onClick={() => window.scrollTo(0, 0)}
                    className="transition-colors hover:text-yellow-400"
                  >
                    Make Payment
                  </Link>
                </li> */}
                <li>
                  <button
                    onClick={() => scrollToSection("resources")}
                    className="transition-colors hover:text-yellow-400"
                  >
                    Resources
                  </button>
                </li>

                <li>
                  <button
                    onClick={() => scrollToSection("testimonials")}
                    className="transition-colors hover:text-yellow-400"
                  >
                    Testimonials
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => scrollToSection("contact")}
                    className="transition-colors hover:text-yellow-400"
                  >
                    Contact
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="mb-4 text-xl font-bold">Contact Info</h3>
              <div className="space-y-3 text-gray-400">
                <div className="flex items-start space-x-2">
                  <svg
                    className="w-5 h-5 text-yellow-400 mt-0.5 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <a
                    href="https://maps.app.goo.gl/vxBFC4HWTFof4oGV8"
                    className="text-sm transition-colors hover:text-yellow-400"
                  >
                    7th Floor, Adharshila Complex, 503, beside Reserve Bank of
                    India(RBI, South Gandhi Maidan, Patna, Bihar 800001
                  </a>
                </div>
                <div className="flex items-center space-x-2">
                  <svg
                    className="flex-shrink-0 w-5 h-5 text-yellow-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  <p>
                    <a
                      href="tel:+917673040500"
                      className="block text-sm transition-colors hover:text-yellow-400"
                    >
                      +91 7673040500
                    </a>

                    <a
                      href="tel:+919334743600"
                      className="block text-sm transition-colors hover:text-yellow-400"
                    >
                      +91 9934743600
                    </a>
                  </p>
                </div>
                <div className="flex items-center space-x-2">
                  <svg
                    className="flex-shrink-0 w-5 h-5 text-yellow-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <a
                    href="mailto:govind@cagovindsinha.com"
                    className="text-sm transition-colors hover:text-yellow-400"
                  >
                    govind@cagovindsinha.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-gray-800">
            <div className="flex flex-col items-center justify-between md:flex-row">
              <p className="mb-4 text-sm text-gray-400 md:mb-0">
                © {year} Govind Sinha & Co. All rights reserved.
                <br />
                Made by{" "}
                <span className="relative inline-block group">
                  <a
                    href="mailto:amansinha@proton.me"
                    className="hover:text-yellow-400"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Aman Kumar Sinha.
                  </a>
                  <div className="absolute px-4 py-2 text-sm font-medium text-gray-800 transition-all duration-300 transform -translate-x-1/2 border shadow-lg opacity-0 bg-white/90 backdrop-blur-md rounded-xl -top-12 left-1/2 group-hover:opacity-100 group-hover:-translate-y-1 whitespace-nowrap border-white/20">
                    <span className="inline-flex items-center gap-2 ">
                      <Mail className="w-4 h-4" />
                      amansinha@proton.me
                    </span>
                    <div className="absolute w-2 h-2 transform rotate-45 -translate-x-1/2 border-b border-r bg-white/90 backdrop-blur-md -bottom-1 left-1/2 border-white/20"></div>
                  </div>
                </span>
              </p>

              <div className="flex space-x-6 text-sm text-gray-400">
                <Link
                  to="/privacy-policy"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="transition-colors hover:text-yellow-400"
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/disclaimer"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="transition-colors hover:text-yellow-400"
                >
                  Disclaimer
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
